import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/home/index'
import dataCenter from '@/views/dataCenter'
import newsInfo from '@/views/news'
import newsDetail from '@/views/news/newsDetail'
import about from '@/views/about'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'hash',
  exact: true,
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '股宇宙数据库',
        keywords: '',
        description: ''
      }
    },
    {
      path: '/dataCenter',
      name: 'dataCenter',
      component: dataCenter,
      meta: {
        title: '股宇宙数据库',
        keywords: '',
        description: ''
      }
    },
    {
      path: '/news',
      name: 'newsInfo',
      component: newsInfo,
      meta: {
        title: '股宇宙数据库',
        keywords: '',
        description: ''
      },
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail,
      meta: {
        title: '股宇宙数据库',
        keywords: '',
        description: ''
      },
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '股宇宙数据库',
        keywords: '',
        description: ''
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js